import { useState } from 'react';
import { FiExternalLink, FiLock, FiUser } from 'react-icons/fi';
import { API_BASE_URL } from '../lib/api';
import { Button, TextInput } from './ui';

interface RedeLoginProps {
  onLogin: (creds: { username: string; password: string }) => Promise<void>;
  loading: boolean;
}

/**
 * Login do módulo Rede.
 *
 * O backend da Rede é externo e tem base de usuários própria — o login do
 * painel não vale lá. Por isso a conexão é feita uma vez aqui e a sessão
 * fica guardada no navegador até o operador desconectar.
 */
export default function RedeLogin({ onLogin, loading }: RedeLoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      setErro('Informe usuário e senha.');
      return;
    }
    setErro('');
    try {
      await onLogin({ username: username.trim(), password });
    } catch (err) {
      setErro((err as Error).message || 'Falha no login.');
    }
  };

  return (
    <div className="flex flex-1 items-center justify-center bg-slate-100 p-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8 shadow-xl">
        <div className="mb-6 text-center">
          <h1 className="text-xl font-bold text-slate-800">Módulo Rede</h1>
          <p className="mt-1 text-sm text-slate-500">
            Conecte-se ao sistema de rede para acessar mapa, ocorrências e rompimentos.
          </p>
        </div>

        <label className="mb-1 block text-xs font-semibold text-slate-600">Usuário</label>
        <div className="relative mb-4">
          <FiUser className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
          <TextInput
            className="pl-9"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="seu usuário"
            autoComplete="username"
          />
        </div>

        <label className="mb-1 block text-xs font-semibold text-slate-600">Senha</label>
        <div className="relative mb-5">
          <FiLock className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
          <TextInput
            className="pl-9"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
          />
        </div>

        {erro && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{erro}</div>
        )}

        <Button type="submit" disabled={loading} className="w-full">
          {loading ? 'Conectando...' : 'Conectar'}
        </Button>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs text-slate-400">
          <FiExternalLink size={12} />
          {API_BASE_URL}
        </p>
      </form>
    </div>
  );
}
